import { useEffect } from 'react';

const HUB_URL = import.meta.env.VITE_HUB_URL ?? 'https://hub.theonestack.com';

export default function LoginPage() {
  useEffect(() => {
    window.location.href = `${HUB_URL}/login?redirect=security`;
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="text-center">
        <p className="text-zinc-400">Redirecting to Hub login...</p>
      </div>
    </div>
  );
}
